import Loader from '@components/common/loader/Loader';
import CreateDoc from '@components/componentDocuments/create';
import { useState } from 'react';

export default function CreateDocument(): JSX.Element {
  const [loader, setLoader] = useState(false);

  return (
    <>
      <Loader isActive={loader} />
      <CreateDoc setLoader={setLoader} />
    </>
  );
}
